import React from "react";
import tick from "../assets/tick-white.svg"
import ticket from "../assets/ticket.svg"
import info from "../assets/info.svg"
import moment from "moment";
import calendar from "../assets/calendar.svg"
import clock from "../assets/clock.svg"
import location from "../assets/location.svg"
import qr from "../assets/qr.jpg"
import mobileYwll from "../assets/mob-ywll.svg"
import download from "../assets/download.svg"
import email from "../assets/email.svg"
import pdf from "../assets/pdf.svg"
import invite from "../assets/invite.svg"
import secure from "../assets/secure.svg"
import support from "../assets/sup-blue.svg"
import mob from "../assets/mob-prp.svg"





const SuccessModal = ({ onClose, event, data }) => {

    const downloadImage = (base64Url) => {
        const link = document.createElement("a");
        link.href = base64Url;
        link.download = "ticket.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <div className="SuccessModal-overlay" onClick={onClose}>
            <div className="SuccessModal-box" onClick={(e) => e.stopPropagation()}>
                <div className="SuccessModal-box-header">
                    <div className="SuccessModal-box-header-icon">
                        <img alt="" src={tick} />
                    </div>
                    <div className="SuccessModal-box-header-title"> Booking Confirmed</div>
                    <div className="SuccessModal-box-header-subtitle">Your tickets are secured and ready</div>

                </div>
                <div className="SuccessModal-box-container">
                    <div className="SuccessModal-box-container-cont">
                        <div className="SuccessModal-ref">
                            <div className="SuccessModal-ref-header">
                                Booking Reference
                                <img alt="" src={ticket} />
                            </div>
                            <div className="SuccessModal-ref-cont">
                                {data?.BookingReference}
                            </div>

                        </div>
                        <div className="SuccessModal-event">
                            <div className="SuccessModal-event-header">
                                Event Details
                                <img alt="" src={info} />
                            </div>
                            <div className="SuccessModal-event-title">{event?.EventTitle}</div>

                            <div className="SuccessModal-event-details">
                                <img alt="" src={calendar} />
                                {moment(event?.EventDate).format('Do MMMM YYYY')}</div><div className="SuccessModal-event-details">
                                <img alt="" src={clock} />
                                {event?.Duration?.StartTime} {event?.Duration?.EndTime ? ` - ${event?.Duration?.EndTime}` : "onwards"}</div>
                            <div className="SuccessModal-event-details">
                                <img alt="" src={location} />
                                {event?.Venue?.Name}, {event?.Venue?.Location}
                            </div>
                        </div>

                    </div>
                    <div className="SuccessModal-box-container-cont">
                        <div className="SuccessModal-qr">
                            <div className="SuccessModal-qr-header">
                                Entry QR Code
                            </div>
                            <div className="SuccessModal-qr-code">
                                <img alt="" src={data?.QRCode} />
                            </div>
                            <div className="SuccessModal-qr-subtext">
                                Show this code at the venue entrance
                            </div>
                            <div className="SuccessModal-qr-content">
                                <img alt="" src={mobileYwll} />
                                Save to your mobile wallet
                            </div>
                        </div>
                        <div className="SuccessModal-digital">
                            <div className="SuccessModal-digital-header">
                                Digital Tickets
                                <img alt="" src={download} />
                            </div>
                            <div className="SuccessModal-digital-details">
                                <img alt="" src={email} />
                                Confirmation sent to your email</div>
                            <div className="SuccessModal-digital-details">
                                <img alt="" src={pdf} />
                                PDF tickets attached</div>
                            <div className="SuccessModal-digital-details">
                                <img alt="" src={invite} />
                                Calendar invite included
                            </div>
                        </div>
                    </div>
                </div>
                <div className="SuccessModal-box-container-bottom">
                    <div className="SuccessModal-box-container-bottom-det">
                        <div className="SuccessModal-cont">
                            <div className="SuccessModal-cont-1">
                                <img alt="" src={secure} />

                            </div>
                            <div className="SuccessModal-cont-header">
                                Secure & Protected
                            </div>
                            <div className="SuccessModal-cont-subheader">
                                Your booking is guaranteed
                            </div>
                        </div>
                        {/* <div className="SuccessModal-cont">
                            <div className="SuccessModal-cont-2">
                                <img alt="" src={support} />

                            </div>
                            <div className="SuccessModal-cont-header">
                                24/7 Support
                            </div>
                            <div className="SuccessModal-cont-subheader">
                                We're here to help
                            </div>
                        </div> */}
                        <div className="SuccessModal-cont">
                            <div className="SuccessModal-cont-2">
                                <img alt="" src={mob} />

                            </div>
                            <div className="SuccessModal-cont-header">
                                Mobile Ready
                            </div>
                            <div className="SuccessModal-cont-subheader">
                                Easy venue entry
                            </div>
                        </div>

                    </div>
                    <div className="SuccessModal-box-container-bottom-button"
                        onClick={() => {
                            downloadImage(data?.QRCode)
                            onClose()
                        }}>
                        Download Tickets & Receipt
                    </div>
                </div>
            </div>

        </div>
    )
}
export default SuccessModal